module.exports = __webpack_public_path__ + "static/Fabriga-Bold-d9c1703d487433cec763923ca211e03f.woff";